import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Sparkles } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const STARS = Array.from({ length: 42 }, (_, i) => ({
    id: i,
    x: Math.random() * 100,
    delay: Math.random() * 0.9,
    duration: 1.6 + Math.random() * 1.8,
    size: 2 + Math.random() * 4,
    drift: -30 + Math.random() * 60,
    gold: Math.random() > 0.6,
}));

export const LaunchStardust = () => {
    const [show, setShow] = useState(false);

    useEffect(() => {
        if (localStorage.getItem("ds_launch_seen")) return;
        let alive = true;
        axios
            .get(`${API}/promo`)
            .then((r) => {
                if (alive && r.data?.active) {
                    setShow(true);
                    localStorage.setItem("ds_launch_seen", "1");
                }
            })
            .catch(() => {});
        return () => {
            alive = false;
        };
    }, []);

    useEffect(() => {
        if (!show) return;
        const t = setTimeout(() => setShow(false), 5200);
        return () => clearTimeout(t);
    }, [show]);

    return (
        <AnimatePresence>
            {show && (
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.8 }}
                    onClick={() => setShow(false)}
                    data-testid="launch-stardust"
                    className="fixed inset-0 z-[90] flex cursor-pointer items-center justify-center overflow-hidden bg-[#06001a]/80 backdrop-blur-sm"
                >
                    {STARS.map((s) => (
                        <motion.span
                            key={s.id}
                            initial={{ y: "110vh", x: 0, opacity: 0 }}
                            animate={{ y: "-10vh", x: `${s.drift}vw`, opacity: [0, 1, 1, 0] }}
                            transition={{ duration: s.duration, delay: s.delay, ease: "easeOut" }}
                            className={`absolute bottom-0 rounded-full ${
                                s.gold ? "bg-[#ffd700]" : "bg-[#e0aaff]"
                            }`}
                            style={{
                                left: `${s.x}%`,
                                width: s.size,
                                height: s.size,
                                boxShadow: s.gold
                                    ? "0 0 12px 3px rgba(255,215,0,0.55)"
                                    : "0 0 12px 3px rgba(199,125,255,0.55)",
                            }}
                        />
                    ))}
                    <motion.div
                        initial={{ opacity: 0, y: 30, scale: 0.96 }}
                        animate={{ opacity: 1, y: 0, scale: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ delay: 0.6, duration: 1 }}
                        className="relative mx-6 max-w-lg text-center"
                    >
                        <Sparkles className="mx-auto h-7 w-7 animate-pulse-soft text-[#ffd700]" />
                        <p className="mt-6 font-cinzel text-xs tracking-[0.4em] text-[#ffd700]/90">
                            YOU ARRIVED DURING THE FREE HOURS
                        </p>
                        <h2 className="text-glow-lilac mt-4 font-display text-3xl font-bold tracking-wide text-[#f8f7ff] sm:text-4xl">
                            THE MIRROR STANDS OPEN
                        </h2>
                        <p className="mt-5 font-cormorant text-xl italic leading-relaxed text-[#e0aaff]/85">
                            Five live minutes with Mara are yours, freely given — step inside before the mirror turns.
                        </p>
                        <p className="mt-8 font-cinzel text-[10px] tracking-[0.3em] text-[#c77dff]/60">
                            TAP ANYWHERE TO ENTER
                        </p>
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};
